export const filterMap = {
   "School": "schools",
   "Class": "classes",
   "Development Pillars": "developmentPillars",
   "Program Name": "programs",
   "Section": "sections",
   "Teacher": "teachers",
   "Student Name": "kidIds",
   "Merit Level": "meritList"
}

// export const reportCardFilter = ["School","Class","Development Pillars","Program Name","Section","Teacher"]
export const reportCardActiveFilter = ["School", "Class", "Section", "Student Name"]
export const studentActiveFilter = ["School", "Class", "Development Pillars", "Program Name", "Section"];
export const teacherActiveFilter = ["School", "Class", "Development Pillars", "Program Name", "Section", "Teacher"];
export const userActiveFilter = ["School", "Class", "Development Pillars", "Program Name", "Section"];
export const galleryActiveFilter = ["School", "Class", "Development Pillars", "Section", "Student Name"];
export const ongoingEventActiveFilter = ["School", "Class", "Program Name", "Section"];
export const pastEventActiveFilter = ["School", "Class", "Program Name", "Section"];
export const kidActiveFilter = ["School", "Class", "Section", "Student Name"];
export const certificateActiveFilter = ["School", "Class", "Program Name", "Section", "Merit Level", "Student Name"];

export const lineChartConfigs = {
   plugins: { legend: { display: false } },
   scales: { x: { grid: { display: false } }, y: { grid: { display: false } } }
}

export const radarConfigs = {
   // maintainAspectRatio: false,
   plugins: {
      legend: {
         display: false,
      },
   },
   backgroundColor: "rgba(255, 255, 255, 0.5)",
   tooltips: { enabled: false },
   // plugins: {
   //    legend: { display: false },
   // },
   legend: { display: false },
   scales: {
      xAxes: [{ display: false }],
      yAxes: [{ display: false }],
      r: {
         pointLabels: {
            font: {
               size: 14,
            },
         },

         min: 0,
         max: 100,
         beginAtZero: true,
         gridLines: {
            color: "black",
            lineWidth: 3,
         },

         grid: {
            color: [
               {
                  color: "#FFD2F0",
                  backgroundColor: "#000",
               },
               "#FFD2F0",
               "#FFD2F0",
               "#FFD2F0",
               "#C41D8E",
            ],
         },

         angleLines: {
            display: false,
         },
         ticks: {
            display: true,
            stepSize: 25,
         },
      },
   },
};

export const studentStatus = {
   ACTIVE: "Active",
   INACTIVE: "Inactive",
   UNDERREVIEW: "Under review",
   APPROVED: "Approved",
   REJECTED: "Rejected"
}

export const classList = {
   1: "Class Nur (Nursery)",
   2: "Class KG (Kindergarten)",
   3: "Class I (1, One)",
   4: "Class II (2, Two)",
   5: "Class III (3, Three)",
   6: "Class IV (4, Four)",
   7: "Class V (5, Five)",
   8: "Class VI (6, Six)",
   9: "Class VII (7, Seven)",
   10: "Class VIII (8, Eight)",
   11: "Class IX (9, Nine)",
   12: "Class X (10, Ten)",
   13: "Class XI (11, Eleven)",
   14: "Class XII (12, Twelve)"
}

export const sectionList = {
   1: "A",
   2: "ASTERS",
   3: "B",
   4: "BLUEBELLS",
   5: "C",
   6: "CARNATIONS",
   7: "D",
   8: "DAISIES"
}

export const meritLevelList = {
   ZONAL: "ZONAL",
   STATE: "STATE",
   CITY: "CITY",
   NATIONAL: "NATIONAL"
}

export const allowedExtensions = [
   "pdf",
   "doc",
   "docx",
   "ppt",
   "pptx",
   "zip",
   "jpg",
   "jpeg",
   "png",
   "gif",
   "avi",
   "mp4",
   "wma",
   "mpg",
   "flv",
   "mp3",
   "mov",
   "mpeg",
   "wmv",
   "qt",
   "swf",
   "avchd",
   "webm",
   "mp2",
   "mpe",
   "mpv",
   "ogg",
   "m4p",
   "m4v",
];


export const gradeLabes = {
   EX: "Expert",
   M: "Master",
   I: "Intermediate",
   B: "Beginner",
   A: "Aspirant",
   NA: "Not Applicable"
}

export const ticketStateList = {
   OPEN: "Open",
   CLOSED: "Closed",
   PARTIALLY_CLOSED: "Partially Closed",
   RESPONDED: "Responded"
}